import gql from "graphql-tag";

const POST_VERIFY_PHONE_CALL_CODE = gql`
  mutation postVerifyPhoneCallCode($body: Object, $phone_number: String) {
    verifyPhoneCallCode(body: $body, phone_number: $phone_number)
      @rest(
        type: "PostVerifyPhoneCallCode"
        path: "/call_non_sms_phone?phone_number={args.phone_number}"
        endpoint: "v1"
        method: "POST"
        bodyKey: "body"
      ) {
      status
    }
  }
`;

export { POST_VERIFY_PHONE_CALL_CODE };
